import { Link } from 'react-router-dom';
import { Activity, ArrowRight } from 'lucide-react';
import { LEVEL_LABELS, RiskLevel } from '../types/risk';
import './RiskHighlights.css';

export interface RiskHighlightItem {
  id: string;
  tipo: string;
  numero: number;
  ano: number;
  ialScore: number;
  ialLevel: RiskLevel;
  oneLiner: string;
}

interface Props {
  highlights: RiskHighlightItem[];
  limit?: number;
  title?: string;
  className?: string;
}

/**
 * Institutional replacement for JabutisHighlights. Renders the top proposicoes
 * by Índice de Atenção Legislativa with a compact card.
 */
export default function RiskHighlights({
  highlights,
  limit = 6,
  title = 'Proposições em destaque · IAL',
  className,
}: Props) {
  if (!highlights || highlights.length === 0) return null;
  const items = highlights.slice(0, limit);

  return (
    <section className={`risk-highlights${className ? ` ${className}` : ''}`}>
      <header className="risk-highlights-header">
        <span className="risk-highlights-eyebrow">
          <Activity size={12} /> {title}
        </span>
        <span className="risk-highlights-sublabel">
          Análise preliminar automatizada — 5 dimensões.
        </span>
      </header>
      <ul className="risk-highlights-list">
        {items.map((h) => (
          <li key={h.id}>
            <Link to={`/detail/${h.id}`} className="risk-highlights-item">
              <span className={`risk-highlights-pill risk-level-${h.ialLevel}`}>
                {LEVEL_LABELS[h.ialLevel]} · {Math.round(h.ialScore)}
              </span>
              <span className="risk-highlights-ref">
                {h.tipo} {h.numero}/{h.ano}
              </span>
              <span className="risk-highlights-line">{h.oneLiner}</span>
              <ArrowRight size={12} className="risk-highlights-arrow" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
